
















































































































































































































































































































import { Vue, Component, Prop } from "vue-property-decorator";
import { StudentAssignmentTirFormativoInfo } from "../../_models/studentAssignmentTirFormativo"

@Component
export default class DeataisTirFormativo extends Vue {
  @Prop() info!: StudentAssignmentTirFormativoInfo;
}
